export default __webpack_public_path__ + "static/escale-9be1d662e05382adfa0a1127edce590a.png";